<script setup>
defineProps({
  isSimpleHeader: { type: Boolean, default: false },
  isHideDonationForm: { type: Boolean, default: false },
  isColoredLogo: { type: Boolean, default: false },
  isPride: { type: Boolean, default: false },
  isTransparentHeader: { type: Boolean, default: false },
  isHideFooter: { type: Boolean, default: false },
});
</script>

<template>
  <div
    :class="{
      'static-layout': true,
      'static-layout--withBackground': !isPride,
      'static-layout--special': isPride,
    }"
  >
    <TheHeaderSpecial v-if="isPride" :is-transparent="isTransparentHeader" />
    <TheHeader
      v-if="!isPride"
      :is-colored-logo="isColoredLogo"
      is-simple-header
    />
    <slot />
    <TheFooter
      v-if="!isHideFooter"
      is-hide-donation-block
      :is-hide-subscription-block="true"
    />
  </div>
</template>

<style lang="postcss" scoped>
.static-layout {
  position: relative;
  background-color: var(--page-background-color);

  &--special {
    &::after {
      content: none;
    }
  }

  &--withBackground {
    &::after {
      position: absolute;
      top: 35%;
      width: 100%;
      height: 1200px;
      content: '';
      background: var(--static-page-gradient);

      @media (--small-vp) {
        top: 25%;
      }
    }
  }
}
</style>
